import React from "react";
import { T } from "./Translate";

// Lista compartida entre Language.js (pantalla /language) y SelectLanguage.js
// (ícono en AccountMenu), así ambas quedan siempre sincronizadas.
export const languages = [
  { code: 'es', name: <T>Español</T>, flag: '🇪🇸' },
  { code: 'en', name: <T>English</T>, flag: '🇺🇸' },
  { code: 'pt', name: <T>Português</T>, flag: '🇧🇷' },
  { code: 'fr', name: <T>Français</T>, flag: '🇫🇷' },
  { code: 'de', name: <T>Deutsch</T>, flag: '🇩🇪' },
  { code: 'it', name: <T>Italiano</T>, flag: '🇮🇹' },
  { code: 'zh', name: <T>中文</T>, flag: '🇨🇳' },
  { code: 'ja', name: <T>日本語</T>, flag: '🇯🇵' },
  { code: 'ru', name: <T>Русский</T>, flag: '🇷🇺' },
  { code: 'ko', name: <T>한국어</T>, flag: '🇰🇷' },
  { code: 'ar', name: <T>العربية</T>, flag: '🇸🇦' },
  { code: 'hi', name: <T>हिन्दी</T>, flag: '🇮🇳' },
  { code: 'nl', name: <T>Nederlands</T>, flag: '🇳🇱' },
  { code: 'tr', name: <T>Türkçe</T>, flag: '🇹🇷' },
  { code: 'pl', name: <T>Polski</T>, flag: '🇵🇱' },
  { code: 'el', name: <T>Ελληνικά</T>, flag: '🇬🇷' },
  { code: 'sv', name: <T>Svenska</T>, flag: '🇸🇪' },
  { code: 'vi', name: <T>Tiếng Việt</T>, flag: '🇻🇳' },
  { code: 'th', name: <T>ไทย</T>, flag: '🇹🇭' },
  { code: 'id', name: <T>Bahasa Indonesia</T>, flag: '🇮🇩' },
  { code: 'uk', name: <T>Українська</T>, flag: '🇺🇦' },
  { code: 'ro', name: <T>Română</T>, flag: '🇷🇴' },
  { code: 'hu', name: <T>Magyar</T>, flag: '🇭🇺' },
  { code: 'cs', name: <T>Čeština</T>, flag: '🇨🇿' },
  { code: 'da', name: <T>Dansk</T>, flag: '🇩🇰' },
  { code: 'no', name: <T>Norsk</T>, flag: '🇳🇴' },
  { code: 'fi', name: <T>Suomi</T>, flag: '🇫🇮' },
  { code: 'he', name: <T>עברית</T>, flag: '🇮🇱' },
  { code: 'fa', name: <T>فارسی</T>, flag: '🇮🇷' },
  { code: 'ur', name: <T>اردو</T>, flag: '🇵🇰' },
  { code: 'bn', name: <T>বাংলা</T>, flag: '🇧🇩' },
  { code: 'ms', name: <T>Bahasa Melayu</T>, flag: '🇲🇾' },
  { code: 'tl', name: <T>Filipino</T>, flag: '🇵🇭' },
  { code: 'sw', name: <T>Kiswahili</T>, flag: '🇰🇪' },
  { code: 'bg', name: <T>Български</T>, flag: '🇧🇬' },
  { code: 'ca', name: <T>Català</T>, flag: '🇪🇸' },
  { code: 'sk', name: <T>Slovenčina</T>, flag: '🇸🇰' },
  { code: 'sl', name: <T>Slovenščina</T>, flag: '🇸🇮' },
  { code: 'sr', name: <T>Српски</T>, flag: '🇷🇸' },
  { code: 'hr', name: <T>Hrvatski</T>, flag: '🇭🇷' },
  { code: 'lt', name: <T>Lietuvių</T>, flag: '🇱🇹' },
  { code: 'lv', name: <T>Latviešu</T>, flag: '🇱🇻' },
  { code: 'et', name: <T>Eesti</T>, flag: '🇪🇪' },
  { code: 'is', name: <T>Íslenska</T>, flag: '🇮🇸' },
  { code: 'sq', name: <T>Shqip</T>, flag: '🇦🇱' },
  { code: 'ka', name: <T>ქართული</T>, flag: '🇬🇪' },
  { code: 'hy', name: <T>Հայերեն</T>, flag: '🇦🇲' },
  { code: 'az', name: <T>Azərbaycan</T>, flag: '🇦🇿' },
  { code: 'kk', name: <T>Қазақ</T>, flag: '🇰🇿' },
  { code: 'mn', name: <T>Монгол</T>, flag: '🇲🇳' },
  { code: 'ne', name: <T>नेपाली</T>, flag: '🇳🇵' },
  { code: 'si', name: <T>සිංහල</T>, flag: '🇱🇰' },
  { code: 'km', name: <T>ខ្មែរ</T>, flag: '🇰🇭' },
  { code: 'lo', name: <T>ລາວ</T>, flag: '🇱🇦' },
  { code: 'my', name: <T>မြန်မာ</T>, flag: '🇲🇲' },
  { code: 'pa', name: <T>ਪੰਜਾਬੀ</T>, flag: '🇮🇳' },
  { code: 'gu', name: <T>ગુજરાતી</T>, flag: '🇮🇳' },
  { code: 'ta', name: <T>தமிழ்</T>, flag: '🇮🇳' },
  { code: 'te', name: <T>తెలుగు</T>, flag: '🇮🇳' },
  { code: 'mr', name: <T>मराठी</T>, flag: '🇮🇳' },
  { code: 'ml', name: <T>മലയാളം</T>, flag: '🇮🇳' },
  { code: 'kn', name: <T>ಕನ್ನಡ</T>, flag: '🇮🇳' },
  { code: 'so', name: <T>Soomaali</T>, flag: '🇸🇴' },
  { code: 'ha', name: <T>Hausa</T>, flag: '🇳🇬' },
  { code: 'yo', name: <T>Yorùbá</T>, flag: '🇳🇬' },
  { code: 'zu', name: <T>isiZulu</T>, flag: '🇿🇦' },
  { code: 'xh', name: <T>isiXhosa</T>, flag: '🇿🇦' },
  { code: 'af', name: <T>Afrikaans</T>, flag: '🇿🇦' },
  { code: 'am', name: <T>አማርኛ</T>, flag: '🇪🇹' },
  { code: 'ht', name: <T>Kreyòl Ayisyen</T>, flag: '🇭🇹' },
  { code: 'cy', name: <T>Cymraeg</T>, flag: '🇬🇧' },
  { code: 'ga', name: <T>Gaeilge</T>, flag: '🇮🇪' },
  { code: 'eu', name: <T>Euskara</T>, flag: '🇪🇸' },
  { code: 'gl', name: <T>Galego</T>, flag: '🇪🇸' },
  { code: 'mi', name: <T>Māori</T>, flag: '🇳🇿' },
];
